// extracted by mini-css-extract-plugin
module.exports = {"errorPlaceholder":"common_errorPlaceholder__Odplb","formGroup":"common_formGroup__pvWez"};